@if (table) {
  <!-- NO DATA MESSAGE BEFORE -->
  @if (table.mustDisplayNoDataMsgBefore()) {
    <ng-template [ngTemplateOutlet]="msgIfNoData"></ng-template>
  }
  <!-- TABLE -->
  @if (table && table.canBeDisplayed()) {
    <table class="table {{table.configuration.displayMode}}" [ngClass]="table.configuration.cssClass">
      <!-- headers -->
      @if (table.header && table.header.cells.length > 0) {
        <thead>
          <tr [ngClass]="table.header.row.cssClass" [class.thead-sticky]="table.configuration.headPosition === 'top'"
            (mouseenter)="onMouseenterRow(table.header.row, tableEventTargetType.HEADER)"
            (mouseleave)="onMouseLeaveRow(table.header.row, tableEventTargetType.HEADER)"
            >
            @for (cell of table.header.cells; track cell) {
              @if (cell.show) {
                <th [attr.data-column_id]="cell.columnId">
                  <span class="wrap-cell">
                    @for (valueCell of cell.valueCells; track valueCell; let i = $index) {
                      <ng-container *ngTemplateOutlet="valueCellTemplate; context:{$implicit: valueCell, dataRow:table.header, cell:cell, valueCellIndex:i, header: true}"></ng-container>
                    }
                  </span>
                </th>
              }
            }
          </tr>
        </thead>
      }
      <!-- rows -->
      @if (table.hasDataRow()) {
        <tbody>
          @for (dataRow of table.dataRow; track dataRow; let i = $index) {
            <tr
              [attr.data-column_id]="i"
              [ngClass]="dataRow.row.cssClass"
              [attr.id]="dataRow.row.obj.uid"
              [class.row-selected]="dataRow.row.isSelected" [class.row-selectable]="dataRow.row.selectable && table.configuration.selectRowMode !== 'NONE'" [class.row-disabled]="dataRow.row.isDisabled"
              (mouseenter)="onMouseenterRow(dataRow.row, tableEventTargetType.DATA_ROW)"
              (mouseleave)="onMouseLeaveRow(dataRow.row, tableEventTargetType.DATA_ROW)"
              (click)="onClickRow(dataRow, tableEventTargetType.DATA_ROW)"
              >
              @for (cell of dataRow.cells; track cell) {
                @if (cell.show) {
                  <td [attr.data-column_id]="cell.columnId" [ngClass]="cell.cssClass">
                    <span class="wrap-cell celltype-{{cell.dataType}}">
                      <!-- THE MAIN CELL VALUE -->
                      @for (valueCell of cell.valueCells; track valueCell; let i = $index) {
                        <ng-container *ngTemplateOutlet="valueCellTemplate; context:{$implicit: valueCell, dataRow:dataRow, cell:cell, valueCellIndex:i}"></ng-container>
                      }
                    </span>
                  </td>
                }
              }
            </tr>
          }
        </tbody>
      } @else {
        @if (table.mustDisplayNoDataMsgInBody()) {
          <tbody>
            <tr>
              <td [attr.colspan]="table.getNbColumn()">
                <ng-template [ngTemplateOutlet]="msgIfNoData"></ng-template>
              </td>
            </tr>
          </tbody>
        }
      }
    </table>
  }
  <!-- NO DATA MESSAGE AFTER -->
  @if (table.mustDisplayNoDataMsgAfter()) {
    <ng-template [ngTemplateOutlet]="msgIfNoData"></ng-template>
  }
}


<!-- TEMPLATES
========================================================-->
<!-- No data & error message is displayed in table body -->

<!-- TEMPLATE MESSAGE IF NO DATA -->
<ng-template #msgIfNoData>
  <p>{{table.configuration.noDataRowMsg}}</p>
</ng-template>


<!-- TEMPLATE TO DISPLAY A VALUE_CELL -->
<ng-template #valueCellTemplate let-valueCell let-dataRow=dataRow let-cell=cell let-valueCellIndex=valueCellIndex let-header=header>
  @if (valueCell.show) {
    <span [attr.data-id]="valueCell.dataId" [ngClass]="valueCell.cssClass" [class.editable]="valueCell.editable" [class.sortable]="cell.sortable" class="wrap-value-cell"
      (click)="onClick(dataRow.row, cell, cell.valueCells[valueCellIndex], $event)" (mouseenter)="onMouseenter(dataRow.row, cell)"
      [matTooltip]="valueCell.tooltip" [matTooltipPosition]="valueCell.tooltipPosition" matTooltipClass="multiline-tooltip">
      <!-- ELEMENT FOR EDITION -->
      @if (valueCell.editable && dataRow.row.isEditMode) {
        @switch (valueCell.htmlElementForEdition) {
          <!-- input -->
          @case ('INPUT') {
            @if (valueCell.dataType === 'DATE') {
              <dp-date-picker  mode='daytime' [config]="valueCell.datePickerConfig" [theme]="'dp-material'" [ngModel]="valueCell.value" (onChange)="onChangeDatePicker(valueCell.dataId, cell.dataType, valueCell, $event, cell, dataRow)"></dp-date-picker>
            }
            <!-- <input *ngIf="valueCell.dataType === 'DATE'" type="text" [value]="valueCell.dateFormat ? (valueCell.displayedValue | date:valueCell.dateFormat) : (valueCell.displayedValue | date:table.configuration.dateFormat)" (change)="updateObListToUpdate(valueCell.dataId, cell.dataType, valueCell, $event.target.value, cell, dataRow)"> -->
            @if (valueCell.dataType !== 'DATE') {
              <input type="text" [value]="valueCell.displayedValue" (change)="updateObListToUpdate(valueCell.dataId, cell.dataType, valueCell, $event.target.value, cell, dataRow)">
            }
          }
          <!-- textarea -->
          @case ('TEXTAREA') {
            <textarea [value]="valueCell.displayedValue" (change)="updateObListToUpdate(valueCell.dataId, cell.dataType, valueCell, $event.target.value, cell, dataRow)"></textarea>
          }
          <!-- select -->
          @case ('SELECT') {
            <app-select class="select" [model]="valueCell.select" (changedValueEventEmitter)="onChangeSelect(valueCell.dataId, cell.dataType, valueCell, $event, cell, dataRow)"></app-select>
          }
        }
      }
      @if (!valueCell.editable || (valueCell.editable && !dataRow.row.isEditMode)) {
        <!-- before -->
        @if (valueCell.iconList && valueCell.iconList.iconBefore) {
          @for (icon of valueCell.iconList.iconBefore; track icon) {
            <ng-container *ngTemplateOutlet="iconTemplate; context:{$implicit: icon}"></ng-container>
          }
        }
        <!--  cell value -->
        @switch (valueCell.tagType) {
          <!-- CASE: span -->
          @case ('span') {
            <span class="value-cell {{valueCell.valueCssClass}}"
              [class.one-line]="valueCell.onOneLine"
              [style.max-width]="valueCell.columnMaxWidth ? valueCell.columnMaxWidth: null">
              @if (valueCell.displayedValue === null) {
                {{table.configuration.nullValueDisplay}}
              } @else {
                <ng-template [ngTemplateOutlet]="viewDateTemplate"></ng-template>
              }
              @if (valueCell.dataType === 'DATE') {
                <ng-container #viewDateTemplate>
                  {{valueCell.dateFormat ? (valueCell.displayedValue | date:valueCell.dateFormat) : (valueCell.displayedValue | date:table.configuration.dateFormat)}}
                </ng-container>
              } @else {
                {{valueCell.displayedValue}}
              }
              <!-- Template default view of STRING data -->
            </span>
          }
          <!-- CASE: button -->
          @case ('button') {
            <button  [routerLink]="valueCell.link" routerLinkActive="active"
              [disabled]="valueCell.isDisabled" class="button value-cell {{valueCell.valueCssClass}}"
              [class.one-line]="valueCell.onOneLine"
              [style.max-width]="valueCell.columnMaxWidth ? valueCell.columnMaxWidth: null"
              (click)="goDetail($event, valueCell.dataId)">
              @if (valueCell.displayedValue === null) {
                {{table.configuration.nullValueDisplay}}
              } @else {
                <ng-template [ngTemplateOutlet]="viewDateTemplateBtn"></ng-template>
              }
              @if (valueCell.dataType === 'DATE') {
                <ng-container #viewDateTemplateBtn>
                  {{valueCell.dateFormat ? (valueCell.displayedValue | date:valueCell.dateFormat) : (valueCell.displayedValue | date:table.configuration.dateFormat)}}
                </ng-container>
              } @else {
                {{valueCell.displayedValue}}
              }
              <!-- Template default view of STRING data -->
            </button>
          }
          <!-- CASE: splitButton -->
          @case ('splitButton') {
            <app-split-button (mainClick)="goDetail($event, valueCell.dataId)" [menu]="menu" [value]="valueCell.displayedValue"></app-split-button>
            <mat-menu #menu="matMenu">
              @for (item of valueCell.menuItems; track item) {
                <button mat-menu-item (click)="item.click()">{{ item.value }}</button>
              }
            </mat-menu>
          }
          <!-- CASE: icon -->
          @case ('icon') {
            <mat-icon [class]="valueCell.valueCssClass" fontSet="fas" [fontIcon]="valueCell.icon"></mat-icon>
          }
          <!-- CASE: badges -->
          @case ('badges') {
            <div class="row">
              <div class="badge">
                <mat-icon class="success" fontSet="fas" fontIcon="fa-lock-open"></mat-icon>
                <span>{{ valueCell.data.active }}</span>
              </div>
              <div class="badge">
                <mat-icon class="danger" fontSet="fas" fontIcon="fa-lock"></mat-icon>
                <span>{{ valueCell.data.redList }}</span>
              </div>
              <div class="badge">
                <mat-icon fontSet="fas" fontIcon="fa-skull-crossbones"></mat-icon>
                <span>{{ valueCell.data.blackList }}</span>
              </div>
            </div>
          }
          <!-- CASE: file -->
          @case ('file') {
            <input [disabled]="valueCell.isDisabled" type="file" [accept]="valueCell.attrAccept" class="value-cell {{valueCell.valueCssClass}}"
              [class.one-line]="valueCell.onOneLine"
              [style.max-width]="valueCell.columnMaxWidth ? valueCell.columnMaxWidth: null"
              (change)="onChangeInputFile(dataRow.row, cell, cell.valueCells[valueCellIndex],$event.target.files)">
          }
          <!-- case: checkbox -->
          @case ('checkbox') {
            <ng-container style="display: flex;">
              <input [disabled]="valueCell.isDisabled" type="checkbox" [accept]="valueCell.attrAccept" class="value-cell {{valueCell.valueCssClass}}"
                [class.one-line]="valueCell.onOneLine" [checked]="valueCell.isChecked">
              <label class="checkbox-label" for="">{{valueCell.displayedValue}}</label>
            </ng-container>
          }
          <!-- CASE: chips -->
          @case ('chips') {
            <mat-chip-list>
              <mat-chip [class]="valueCell.valueCssClass">
                <div class="mat-chip-content">
                  @if (valueCell.icon) {
                    <mat-icon class="mat-chip-icon" fontSet="fas" [fontIcon]="valueCell.icon"></mat-icon>
                  }
                  {{ valueCell.displayedValue }}
                </div>
              </mat-chip>
            </mat-chip-list>
          }
          <!-- CASE: multiSelection -->
          @case ('multiSelection') {
            <input [disabled]="valueCell.isDisabled" type="checkbox" [accept]="valueCell.attrAccept" class="value-cell {{valueCell.valueCssClass}}"
              [class.one-line]="valueCell.onOneLine" [checked]="valueCell.isChecked">
            <label class="checkbox-label" (click)="onSelectRow(cell, header)"></label>
          }
        }
        <!-- after -->
        @if (valueCell.iconList && valueCell.iconList.iconAfter) {
          @for (icon of valueCell.iconList.iconAfter; track icon) {
            <ng-container *ngTemplateOutlet="iconTemplate; context:{$implicit: icon}"></ng-container>
          }
        }
      }
    </span>
  }
  @if (valueCell.htmlContent) {
    <div [innerHTML]="valueCell.htmlContent | safeHtml"></div>
  }
</ng-template>



<!-- TEMPLATE TO DISPLAY A UI_ICON -->
<ng-template #iconTemplate let-icon>
  @switch (icon.type) {
    @case (iconType.ICOMOON) {
      <span class="{{icon.value}} table-icon" [ngClass]="icon.cssClass" [attr.title]="icon.title" [attr.data-id]="icon.dataId" [attr.data-attr]="icon.dataAttr" [ngStyle]="icon.style"></span>
    }
    @case (iconType.FONTAWESOME) {
      <span class="{{icon.value}} table-icon" [ngClass]="icon.cssClass" [attr.title]="icon.title" [attr.data-id]="icon.dataId" [attr.data-attr]="icon.dataAttr" [ngStyle]="icon.style"></span>
    }
    @case (iconType.SRC) {
      <img class="{{icon.value}} table-icon" [ngClass]="icon.cssClass" [attr.title]="icon.title" [src]="icon.value" [attr.data-id]="icon.dataId" [attr.data-attr]="icon.dataAttr" [ngStyle]="icon.style">
    }
  }
</ng-template>
